import { EmployeeService, type IEmployeeService } from "./Employee";
import { RolesService, type IRolesService } from "./Roles";

/**
 * Interface representing the team service.
 * @interface ITeamService
 * @property {IEmployeeService} employee - The service for managing employees.
 * @property {IRolesService} roles - The service for managing roles.
 */
export interface ITeamService {
  employee: IEmployeeService;
  roles: IRolesService;
}

/**
 * Class representing the team service implementation.
 * @class TeamService
 * @implements {ITeamService}
 */
export class TeamService implements ITeamService {
  employee: IEmployeeService;
  roles: IRolesService;

  /**
   * Creates an instance of TeamService.
   * @param {any} api - The API instance used for service operations.
   */
  constructor(api) {
    this.employee = new EmployeeService(api);
    this.roles = new RolesService(api);
  }
}
